export default "__VITE_ASSET__CxdRldCU__"